import React from 'react'
import { useTranslation } from 'react-i18next';

export const GENDERS = ["female", "male", "other"]

function GendersLegend(props) {
    const { onClick, selectedGenderKey } = props

    const { t } = useTranslation('common');

    return (
        <div className="dashboardView-legend">
            {GENDERS.map(gender => (
                <button
                    {...props}
                    key={gender.key}
                    className={`dashboardView-legend-button ${gender} ${selectedGenderKey ? selectedGenderKey === gender ? "selected" : "inactive" : ""}`}
                    onClick={() => onClick(gender)}
                >
                    <span className="k-icon k-font-icon k-i-round-corners"></span> <span>{t(`${gender}`)}</span>
                </button>
            ))}
        </div>
    )
}

export default GendersLegend